<div class="gallery-wrapper">
  @if ( ((screenSize$ | async) !== 'phone' && desktopVariant === 'default') || ((screenSize$ | async) === 'phone' &&
  mobileVariant === 'default') ) {
  <div class="gallery-default-container" [class]="{ zoomable: enableZoom, zoomed: zoomed }">
    <div class="slider-elements">
      <swiper
        [config]="swiperOptions"
        (swiper)="sliderInit()"
        (slideChange)="sliderChange($event)"
        class="slider-swiper"
        #swiperSlider>
        @for (slide of slides; track identifyByIndex(i); let i = $index) {
        <ng-template swiperSlide>
          <div class="swiper-slide-item-wrapper cursor-pointer" (click)="toggleZoom(i)">
            <div class="swiper-slide-item">
              <div class="video__thumbnail">
                <img
                  [src]="'https://img.youtube.com/vi/' + extractVideoId(slide.resource) + '/hqdefault.jpg'"
                  width="100%"
                  height="auto"
                  [alt]="slide.resource"
                  *ngIf="slide.provider === 'YOUTUBE'; else genericPreview" />
                <ng-template #genericPreview>
                  <planone-file-video-embed
                    [path]="slide.resource"
                    [controls]="false"
                    width="100%"
                    height="auto"
                    class="video__thumbnailplaceholder"></planone-file-video-embed>
                </ng-template>
                <span class="video__play" [class.video__play--youtube]="slide.provider === 'YOUTUBE'"></span>
              </div>
            </div>
          </div>
        </ng-template>
        }
      </swiper>
    </div>
    @if (showSlideNav || showSlideControl) {
    <div class="slider-meta">
      @if (showSlideNav) {
      <div class="slider-meta-dots">
        @if (slides) { @for (slide of slides; track identifyByIndex(i); let i = $index) {
        <div
          class="slider-dots-item"
          [class]="{ 'slider-item-active': i + 1 === slideActive }"
          (click)="sliderSlide(i)"></div>
        } }
      </div>
      } @if (showSlideControl) {
      <div class="slider-meta-buttons">
        @if (!((slideActive ?? 0) <= 1)) {
        <div class="slider-elements-control slider-elements-control-previous" (click)="sliderPrevious()">
          <mat-icon class="chevron-left default">chevron_left</mat-icon>
        </div>
        } @if ((slideActive ?? 0) + (slideVisibleCount ?? 0) - 1 < (slideCount ?? 0)) {
        <div class="slider-elements-control slider-elements-control-next" (click)="sliderNext()">
          <mat-icon class="chevron-right default">chevron_left</mat-icon>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  } @if ((screenSize$ | async) !== 'phone' && desktopVariant === 'list') {
  <div class="gallery-list-container" [class]="{ zoomable: enableZoom, 'aspect-less': !forceAspectRatio }">
    <div class="gallery-content gallery-content__hidden gallery-content__hidden--collapsed" #referenceElement>
      @for (slide of slides; track identifyByIndex(i); let i = $index) {
      <div class="gallery-item" [class]="{ zoomed: zoomed && zoomedIndex === i }" (click)="toggleZoom(i)">
        <div class="gallery-item-inner zoomed-background">
          <div class="video__thumbnail">
            <img
              [src]="'https://img.youtube.com/vi/' + extractVideoId(slide.resource) + '/hqdefault.jpg'"
              width="100%"
              height="auto"
              [alt]="slide.resource"
              *ngIf="slide.provider === 'YOUTUBE'; else genericPreview" />
            <ng-template #genericPreview>
              <planone-file-video-embed
                [path]="slide.resource"
                [controls]="false"
                width="100%"
                height="auto"
                class="video__thumbnailplaceholder"></planone-file-video-embed>
            </ng-template>
            <span class="video__play" [class.video__play--youtube]="slide.provider === 'YOUTUBE'"></span>
          </div>
        </div>
      </div>
      }
    </div>
    @if ((screenSize$ | async) !== 'phone' && desktopVariant === 'list') {
    <div class="gallery-list-container" [class]="{ zoomable: enableZoom, 'aspect-less': !forceAspectRatio }">
      <div class="gallery-content gallery-content__hidden gallery-content__hidden--collapsed" #videoElement>
        @for (slide of slides | slice : 0 : videosLimit; track identifyByIndex(i); let i = $index) {
        <div class="gallery-item" [class]="{ zoomed: zoomed && zoomedIndex === i }" (click)="toggleZoom(i)">
          <div class="gallery-item-inner zoomed-background">
            <div class="video__thumbnail">
              <img
                [src]="'https://img.youtube.com/vi/' + extractVideoId(slide.resource) + '/hqdefault.jpg'"
                width="100%"
                height="auto"
                [alt]="slide.resource"
                *ngIf="slide.provider === 'YOUTUBE'; else genericPreview" />
              <ng-template #genericPreview>
                <planone-file-video-embed
                  [path]="slide.resource"
                  [controls]="false"
                  width="100%"
                  height="auto"
                  class="video__thumbnailplaceholder"></planone-file-video-embed>
              </ng-template>
              <span class="video__play" [class.video__play--youtube]="slide.provider === 'YOUTUBE'"></span>
            </div>
          </div>
        </div>
        }
      </div>
      <div class="gallery-content" [ngStyle]="{ 'max-height.px': maxHeight }">
        @for (slide of slides; track identifyByIndex(i); let i = $index) {
        <div class="gallery-item" [class]="{ zoomed: zoomed && zoomedIndex === i }" (click)="toggleZoom(i)">
          <div class="gallery-item-inner zoomed-background">
            <div class="video__thumbnail">
              <img
                [src]="'https://img.youtube.com/vi/' + extractVideoId(slide.resource) + '/hqdefault.jpg'"
                width="100%"
                height="auto"
                [alt]="slide.resource"
                *ngIf="slide.provider === 'YOUTUBE'; else genericPreview" />
              <ng-template #genericPreview>
                <planone-file-video-embed
                  [path]="slide.resource"
                  [controls]="false"
                  width="100%"
                  height="auto"
                  class="video__thumbnailplaceholder"></planone-file-video-embed>
              </ng-template>
              <span class="video__play" [class.video__play--youtube]="slide.provider === 'YOUTUBE'"></span>
            </div>
          </div>
        </div>
        }
      </div>
      <div class="gallery-expand">
        @if (videosOverflowing) {
        <a class="expandable-button" (click)="toggle()">
          @if (!videosExpanded) {
          <ng-container i18n="@@uiElements-swiper-more"> + Alle anzeigen ({{ slides?.length ?? '0' }}) </ng-container>
          } @if (videosExpanded) {
          <ng-container i18n="@@uiElements-swiper-less">- Weniger anzeigen</ng-container>
          }
        </a>
        }
      </div>
    </div>
    }
  </div>
  }
</div>
